// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/aerodrome-signs.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/aerodrome-signs/aerodrome-signs.js';

mount([g0]);
